<template>
  <div class="content">
    <div class="detail">
      <div class="titleline">
        <p class="title">{{title}}</p>
        <div class="info">
          <span class="card" @click="showCard(all.user_id, $event)">{{author}}</span>
          <span class="time">{{time}}</span>
        </div>
      </div>
      <div class="content">{{content}}</div>
      <div class="besides">
        <div class="item">
          <span class="title">标签</span>
          <div class="right">
            <p class="tag" v-for="(t, i) in tags" :key="i" @click="goTags(t)">{{t}}</p>
            <p v-if="tags.length === 0" class="none">无</p>
          </div>
        </div>
        <div class="item">
          <span class="title">备注</span>
          <p :class="{remark: true, none: !remark}">{{remark || '无'}}</p>
        </div>
      </div>
    </div>
    <div class="records">
      <div class="tabs">
        <p :class="{tab: true, on: $_syscfg.interview === selectedTab.title}" @click="selectTab({
          title: $_syscfg.interview,
          code: 1
        })" v-if="all.interviewExist">
          {{`${$_syscfg.interview} ${interviewsLength}`}}
        </p>
        <p :class="{tab: true, on: $_syscfg.clue === selectedTab.title}" @click="selectTab({
          title: $_syscfg.clue,
          code: 2
        })" v-if="all.materialExist">
          {{`${$_syscfg.clue} ${cluesLength}`}}
        </p>
        <p :class="{tab: true, on: $_syscfg.report === selectedTab.title}" @click="selectTab({
          title: $_syscfg.report,
          code: 3
        })" v-if="all.reportExist">
          {{`${$_syscfg.report} ${reportsLength}`}}
        </p>
      </div>
      <div class="headline" v-if="relates.length > 0">
        <span class="title">主题</span>
        <span class="publisher">发布者</span>
        <span class="time">发布时间</span>
      </div>
      <div :class="{container: true,empty: relates.length === 0}" ref="container">
        <empty :msg="`暂无${selectedTab.title}数据`" style="margin-top: -20px" v-if="relates.length === 0" />
        <div class="content" v-for="(i, d) in relates" :key="d">
          <div class="item">
            <div class="title" @click="goDetail(i)">
              <p class="words">{{i.title}}</p>
            </div>
            <div class="publisher">
              {{i.user_name}}
            </div>
            <div class="time">
              {{i.raw_add_time}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footline" v-if="all.has_interview_role" :style="{width: `calc(100vw - ${footLineGap}px)`}">
      <div class="btn" @click="goItv()">发布任务</div>
    </div>
  </div>
</template>

<script>
import common from '@common/common'
import { apis } from '@common/config'
import empty from '@components/empty'
import dc from '@common/dc'

export default {
  name: 'topicDetail',
  components: {
    empty
  },
  data() {
    return {
      isXnew: this.$store.state.isXnew,
      title: '',
      author: '',
      time: '',
      content: '',
      tags: [],
      remark: '',
      interviewsLength: 0,
      cluesLength: 0,
      reportsLength: 0,
      // interviews: [],
      // clues: [],
      // reports: [],
      relates: [],
      types: [
        {
          title: '',
          code: 1
        },
        {
          title: '',
          code: 2
        },
        {
          title: '',
          code: 3
        }],
      selectedTab: {},
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: null
      },
      scrollLock: false,
      all: {},
      footLineGap: 230
    }
  },
  methods: {
    showCard(id, e) {
      if (id == 0) return

      const el = e.target

      this.$card(id, el)
    },
    goTags(t) {
      let name = 'topics'
      const f = this.$route.query.f
      if (f === 'm') {
        name = 'myTopics'
      }

      this.$router.push({
        name: name,
        params: {
          tag: t
        }
      })
    },
    goDetail(i) {
      // 跳转相应详情
      const id = i.id
      const type = this.selectedTab.code
      if (type === 1) {
        // 采访
        if (!this.all.has_interview_detail_role) {
          this.$toast('无访问权限')
          return
        }

        this.$router.push({
          path: '/interviewDetail',
          query: {
            r: id
          }
        })
      } else if (type === 2) {
        // 线索
        if (!this.all.has_material_detail_role) {
          this.$toast('无访问权限')
          return
        }

        common.jump(`/clueDetail?d=${id}`, true)
      } else {
        // 报道
        if (!this.all.has_report_detail_role) {
          this.$toast('无访问权限')
          return
        }

        common.jump(`/reportDetail?d=${id}`, true)
      }
    },
    selectTab(t) {
      this.selectedTab = t
      this.$set(this.page, 'pageIndex', 1)
      this.relates = []
      this.getWiths()
    },
    getDetail() {
      const d = this.$route.query.d
      const info = {
        id: d
      }

      common.myFetch(apis.Tpc_detail, info)
        .then((data) => {
          this.matchData(data.detail)
        })
    },
    matchData(d) {
      // 详情数据匹配填充
      this.all = d
      this.title = d.title
      this.author = d.user_name
      this.time = d.raw_add_time
      this.content = d.content
      this.tags = d.tags.map(i => { return i.title })
      this.remark = d.remark
      this.interviewsLength = d.interview_num
      this.cluesLength = d.material_num
      this.reportsLength = d.report_num

      this.matchTypeToConfig()
    },
    getWiths() {
      // 获取关联内容
      if (this.page.totalPage && this.page.pageIndex > this.page.totalPage) return
      this.scrollLock = true
      const info = {
        id: this.$route.query.d,
        relate_type: this.selectedTab.code, // 1:采访 2:线索 3:报道
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      common.myFetch(apis.Tpc_detail_withs, info)
        .then((data) => {
          this.page.pageIndex += 1
          this.relates = this.relates.concat(data.list)
          this.page.totalPage = data.page.page_count
          this.scrollLock = false
        })
    },
    handleScroll() {
      const container = this.$refs.container
      container.addEventListener('scroll', () => {
        const scrolltop = container.scrollTop;
        const scrollheight = container.scrollHeight;
        const clientheight = container.clientHeight;

        if (scrolltop + clientheight >= scrollheight) {
          if (this.scrollLock) return
          this.getWiths()
        }
      }, false)
    },
    goItv() {
      // 发布选题，去采访
      const t = {
        id: this.$route.query.d,
        title: this.title
      }

      dc.setTpc(t)

      this.$router.push({
        name: 'newInterview',
        params: {
          topic: t
        }
      })

      setTimeout(() => {
        dc.delTpc()
      }, 500)
    },
    matchTypeToConfig() {
      // 把类型数据名称按照接口配置更改
      this.types.forEach(i => {
        if (i.code == 1) {
          i.title = this.$_syscfg.interview
          i.enable = !!this.all.interviewExist
        } else if (i.code == 2) {
          i.title = this.$_syscfg.clue
          i.enable = !!this.all.materialExist
        } else if (i.code == 3) {
          i.title = this.$_syscfg.report
          i.enable = !!this.all.reportExist
        }
      })

      const first = this.types.filter(t => t.enable)[0]
      this.selectTab(first)
    }
  },
  mounted() {
    this.getDetail()
    this.handleScroll()
  },
  created() {
    common.goTop()
  }
}
</script>

<style lang="less" src="@assets/css/topic/topicDetail.less" scoped></style>
